function CategoryChips({ categories, active, counts, onChange }) {
  const items = ['All', ...categories];

  return (
    <div className="category-scroller" aria-label="App categories">
      {items.map((category) => (
        <button
          className={`category-chip ${active === category ? 'active' : ''}`}
          type="button"
          aria-pressed={active === category}
          key={category}
          onClick={() => onChange(active === category && category !== 'All' ? 'All' : category)}
        >
          {category}
          <span className="mono">· {counts[category] || 0}</span>
        </button>
      ))}
    </div>
  );
}

export default CategoryChips;